export const topBarHeight = 54
export const drawerWidth = 290
